<template>
    <banner-description
      title="nursing.nursingHelpline"
      titleColor="#603813"
      :starIconObj="{ componentName: 'shared', imgName: 'starIconPurple', imgFormat: 'svg' }"
      :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconPurpleLeft', imgFormat: 'svg', position: 'top: 10%' }"
      :imgObj="{ componentName: 'nursing', imgName: 'nursingHelpline', imgFormat: 'svg' }"
      description="nursing.nursingHelplineDesc"
      descColor="#4E4E4E"
      class="pb-24"
    />
</template>

<script setup lang="ts">
import { useNursingStore } from "@/stores/nursing";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const nursingStore = useNursingStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
    router.push({ name: position, params: { uid: "lczmx" } });
};
</script>
